import React from 'react'
// import Interface from './Interface'
import {Flex} from './layout'
import MenuItemSoon from './_MenuItemSoon'
import Superface from '../Superface'
import Overline from './_Overline';

export default class Menu extends React.Component{
    
    render(){
        const { open, section, contact } = this.props
        // console.log(contact)
        if( !contact ) return <span></span>

        const items = [
            { slug : 'notre-metier', display : 'Notre métier' },
            { slug : 'matieres', display : 'Matières' },
            { slug : 'projets', display : 'Projets' },
            { slug : 'contact', display : 'Contact' },
        ]
        
        return(

            <div id="main-menu" className={ ( open ? 'open' : '') + ' menu-' + this.props.section } style={{height:'100%'}}>
               
                <Flex
                        justify='center'
                        align='center'
                        style={{width:'100%', height:'100vh', position:'absolute', zIndex:1351 }}
                        >

                            <Flex direction='column' justify='center' align='center'>
                                {
                                    items.map( (item, i) => {
                                        if( i === 2 ) return <MenuItemSoon key={'menu-item ' + i} display={item.display} style={{marginBottom:'2rem'}}/>
                                        return(
                                            <div key={'menu-item ' + i } className="menu-item" style={{marginBottom:'2rem'}}>
                                                <span 
                                                    className={'overline-link ' + (section === item.slug ? 'active' : '') } 
                                                    onClick={ () => { 
                                                        if( section !== item.slug ) Superface.goTo( Superface.uri(item.slug) ) 
                                                    }}>
                                                    <Overline>{ Superface.translate(item.display) }</Overline>
                                                </span>
                                            </div>
                                        )
                                    })
                                }
                                
                            </Flex>

                            <Flex justify="space-between" style={{position:'absolute', bottom : '3rem', left:'3rem', right:'3rem'}}>
                            
                                <div id='menu-languages' style={{width:'150px', textAlign:'left', cursor:'pointer'}}>
                                    <span style={{ textDecoration : Superface.getLang() !== 'fr' ? 'none' : 'line-through'}} onClick={ (e) => { Superface.setLang('fr') }}>Fr</span>
                                    &nbsp;&nbsp;&nbsp;
                                    <span style={{ textDecoration : Superface.getLang() !== 'en' ? 'none' : 'line-through'}} onClick={ (e) => { Superface.setLang('en') }}>En</span>
                                </div>
                                
                                <div style={{width:'150px', textAlign:'right'}}>
                                    
                                    <a className="icon" href={ contact.facebook } target="_blank">
                                        <img src={require('../images/facebook-black.svg')} alt="facebook"/>
                                    </a>
                                    
                                    <a className="icon" href={ contact.instagram  } target="_blank">
                                        <img src={require('../images/instagram-black.svg')} alt="instagram"/>
                                    </a>

                                </div>

                            </Flex>                            

                    </Flex>
            </div>
        )
        
    }
}


// WEBPACK FOOTER //
// ./src/components/_Menu.js